import React from "react"
import style from "./style.module.scss"

export default () => {
  return (
    <div className="op__block" data-aos="fade-up" data-aos-delay="200">
      <div className="container-fluid">
        <div className={style.list}>
          <h3>Graphic design</h3>
          <div className="row">
            <div className="col-lg-4">
              <span className={style.list__title}>Web & Mobile Design</span>
              <p className="text-muted">
                We don't skim through the details, we want the best for maximum compatibilty while retaining your identity.
              </p>
            </div>
            <div className="col-lg-4">
              <span className={style.list__title}>Visual Identity</span>
              <p className="text-muted">
                Level up you service by treating your clients to a unique and inspired look.
              </p>
            </div>
            <div className="col-lg-4">
              <span className={style.list__title}>Animations</span>
              <p className="text-muted">
                Provide your clients with an experience that they never realized they wanted before.    </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
